(ns ui.view.survey.helpers
  (:require [common.util :as cu]))

(defn resolve-indexed-questions
  [configuration]
  (->> configuration
       :blocks
       (mapcat (fn [{:keys [block-type content] :as block}]
                 (case block-type
                   :survey-block/section
                   (->> content
                        (cu/filter-by :survey-item-type :survey-item/question))
                   nil)))
       (remove (fn [q]
                 (= 0 (:survey-question-id q))))
       (map-indexed (fn [idx q]
                      (assoc q :index (inc idx))))))

